import { Component, EventEmitter, Output } from '@angular/core';
import { AuthService } from '@bidi/common-services';

@Component({
  selector: 'bidi-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrls: ['./header-v2.component.scss']
})
export class HeaderV2Component {
  @Output() viewNotifications = new EventEmitter();

  constructor (public auth: AuthService) {
  }

  openLeftPanel (panel) {
    this.viewNotifications.emit(panel);
  }
}
